export enum LegalAgreementFormKeyEnum {
    Agreement = 'agreement',
    RulesConfirmation = 'rulesConfirmation',
    ConsentToReceiveMailings = 'consentToReceiveMailings',
}

export enum LegalAgreementTypeEnum {
    Personal = 'personal',
    Public = 'public',
}

export type LegalAgreementFormType = {
    [LegalAgreementFormKeyEnum.Agreement]: LegalAgreementTypeEnum;
    [LegalAgreementFormKeyEnum.RulesConfirmation]: boolean;
    [LegalAgreementFormKeyEnum.ConsentToReceiveMailings]?: boolean;
};
